export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-8.c2c3575d.jpg";